import { gql } from '@apollo/client';

export const getLabelCollection = gql`
	query getLabelCollection($lang: String) {
		labelCollection(locale: $lang) {
			items {
				key
				value
			}
		}
	}
`;
